import { Reducer } from 'react';
import { GlobalContextActionTypes, ReducerAction } from './actions';
import { GlobalContextType } from './index';
export const reducer: Reducer<GlobalContextType, ReducerAction> = (state, action) => {
    switch (action.type) {
        case GlobalContextActionTypes.SetHandleCaseSave: {
            return {
                ...state,
                handleCaseSave: action.payload as GlobalContextType['handleCaseSave']
            };
        }
        default:
            return state;
    }
};
